import { useEffect, useState } from "react";
import { Outlet, useMatches } from "react-router-dom";
import classNames from "classnames";
import PageState from "../shell/PageState";
import Header from "../shell/header/Header";
import { getHeaderProps } from "../shell/header/Helpers";
import Notification from "../shell/notification/Notification";
import { Loading } from "../elements/Loading";
import SessionRenewal from "../shell/SessionRenewal";
import {
  useGlobalReducer,
  useGlobalState,
} from "../../GlobalContext";
import GlobalDispatchMethods from "../context/globalDispatchMethods";
import {
  getCurrentPageInfo,
  getNavigationItemsToShow,
} from "../shell/sidebar/Helpers";
import { PageProvider } from "../context/PageProvider";
import { PageMenu } from "../menu/PageMenu";
import { getMenuMode } from "./pageRouteHandle";

export function PageLayout() {
  const globalDispatch = useGlobalReducer();
  const globalState = useGlobalState();
  const menuMode = getMenuMode(useMatches());
  // Its own state for a page whose menu starts closed, so opening it there doesn't
  // change the saved preference every other page follows.
  const [pageMenuOpen, setPageMenuOpen] = useState(false);

  useEffect(() => setPageMenuOpen(false), [menuMode]);

  const { initialStateBound, organisation, showNavigation, user } = globalState;

  const hideNavigation = menuMode === "hidden";
  const menuOpen =
    menuMode === "closed" ? pageMenuOpen : showNavigation && !hideNavigation;

  const menuItems = getNavigationItemsToShow(globalState);
  const { display, subDisplay } = getCurrentPageInfo(menuItems);
  const headerProps = getHeaderProps(globalState);

  return (
    <>
      <PageState />
      <PageProvider
        menuOpen={menuOpen}
        onToggleMenu={() =>
          menuMode === "closed"
            ? setPageMenuOpen((open) => !open)
            : globalDispatch({
                type: GlobalDispatchMethods.ToggleSideBar,
              })
        }
        currentUserRoles={user?.userRoles}
        menuItems={menuItems}
        activeItemId={display}
        activeSubItemId={subDisplay}
        organisationName={organisation || undefined}
        organisationResolved={Boolean(initialStateBound)}
      >
        <main
          className={classNames(
            menuOpen ? "sidebar-expanded" : ""
          )}
        >
          <PageMenu logoOnly={hideNavigation} />
          <div id="content-container">
            <Header {...headerProps} empty={hideNavigation} />
            <div id="content" className="content--fills">
              <SessionRenewal />
              {initialStateBound ? (
                <Outlet />
              ) : (
                <div className="d-flex align-items-center justify-content-center">
                  <Loading />
                </div>
              )}
            </div>
          </div>
          <Notification className="toast-container--above-footer" />
        </main>
      </PageProvider>
    </>
  );
}

export default PageLayout;
